module.exports = __webpack_public_path__ + "img/ai-avatar.fce6ede6.webp";